import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Promise from 'babel-runtime/core-js/promise';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import Keycloak from 'keycloak-js';
import RestService from '../RestService';

var KeycloakService = function () {
  function KeycloakService() {
    _classCallCheck(this, KeycloakService);
  }

  _createClass(KeycloakService, [{
    key: 'getToken',
    value: function getToken() {
      var KS = KeycloakService;
      return new _Promise(function (resolve, reject) {
        if (KS.keycloak.token) {
          // updateToken() - checks if the Access Token has more then 4 minutes before expiration,
          // and updates it with the refresh token otherwise
          KS.keycloak.updateToken(240).then(function () {
            resolve(KS.keycloak.token);
          }).catch(function () {
            KS.login();
            reject(new Error('Failed to refresh token'));
          });
        } else {
          KS.login();
        }
      });
    }
  }], [{
    key: 'init',
    // This is environment dependant (test, staging, prod ...).

    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var KS, hostname, keycloakConfiguration;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                KS = KeycloakService;
                hostname = window.location.hostname;
                keycloakConfiguration = {
                  realm: 'customer',
                  url: 'https://auth.paston.cloud',
                  clientId: 'oauth'
                };

                keycloakConfiguration.realm = hostname.split('.')[0];
                KS.keycloak = new Keycloak(keycloakConfiguration); // This is initialization of Keycloak for authentication purpose.

                return _context.abrupt('return', new _Promise(function (resolve, reject) {
                  KS.keycloak.init(KS.keycloakInitOptions).then(function () {
                    // Keycloak initialization passed.
                    KS.environmentConfiguration = keycloakConfiguration;
                    resolve();
                  }) // keep the console log , the logger is not yet initialized
                  .catch(function (error) {
                    return console.error('Error while bootstrapping keycloak: ' + error);
                  });
                }));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _ref.apply(this, arguments);
      }

      return init;
    }()

    // Keycloak setter used only for unit testing

  }, {
    key: 'setMockedKeycloak',
    value: function setMockedKeycloak(mockedKeycloak) {
      KeycloakService.keycloak = mockedKeycloak;
    }
  }, {
    key: 'getUsersRealm',
    value: function getUsersRealm() {
      // This is used only in master realm mode (user management) to retrieve paston realm ('Paston' / 'Staging' / 'Test')
      return KeycloakService.environmentConfiguration.realm;
    }
  }, {
    key: 'getUsersClient',
    value: function getUsersClient() {
      // This is used only in master realm mode (user management) to retrieve paston clientId (typically 'oauth')
      return KeycloakService.environmentConfiguration.clientId;
    }
  }, {
    key: 'getKeycloakAuthUrl',
    value: function getKeycloakAuthUrl() {
      // This is used in both master / paston realm mode
      return KeycloakService.environmentConfiguration['url'];
    }
  }, {
    key: 'authenticated',
    value: function authenticated() {
      return KeycloakService.keycloak.authenticated;
    }
  }, {
    key: 'canActivate',
    value: function canActivate() {
      if (KeycloakService.authenticated()) {
        return true;
      } else {
        this.login();
        return false;
      }
    }
  }, {
    key: 'login',
    value: function login() {
      KeycloakService.keycloak.login();
    }
  }, {
    key: 'logout',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var rest;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                rest = new RestService();
                _context2.prev = 1;
                _context2.next = 4;
                return rest.cleanup();

              case 4:
                _context2.next = 9;
                break;

              case 6:
                _context2.prev = 6;
                _context2.t0 = _context2['catch'](1);

                console.error('Clear-Site-Data cleanup failed', _context2.t0);

              case 9:
                _context2.prev = 9;

                KeycloakService.keycloak.logout();
                return _context2.finish(9);

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[1, 6, 9, 12]]);
      }));

      function logout() {
        return _ref2.apply(this, arguments);
      }

      return logout;
    }()
  }, {
    key: 'account',
    value: function account() {
      KeycloakService.keycloak.accountManagement();
    }
  }, {
    key: 'hasRole',
    value: function hasRole(role) {
      return KeycloakService.keycloak.hasResourceRole(role);
    }
  }, {
    key: 'isAdmin',
    value: function isAdmin() {
      return KeycloakService.keycloak.hasResourceRole('admin');
    }
  }, {
    key: 'isRoleBasedAccessAllowed',
    value: function isRoleBasedAccessAllowed(roles) {
      return roles.some(function (role) {
        return KeycloakService.hasRole(role);
      });
    }
  }, {
    key: 'getLanguage',
    value: function getLanguage() {
      return KeycloakService.keycloak.tokenParsed.locale;
    }
  }]);

  return KeycloakService;
}();

KeycloakService.keycloakInitOptions = { onLoad: 'check-sso', checkLoginIframe: false };
export default KeycloakService;


// WEBPACK FOOTER //
// ./src/service/keycloak/KeycloakService.js